var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"icon":"el-icon-user","type":"primary","size":"mini","round":""}},[_vm._v("选择人员")])
}
var staticRenderFns = []

export { render, staticRenderFns }